module.exports = __webpack_public_path__ + "static/Athens-caccfcd971566ddba9dfeb487c70a59d.png";